import { defineMessages } from "react-intl";

const profileListingSectionTitles = defineMessages({
  Event: { defaultMessage: "Event listings" },
  "Off-Site": {
    defaultMessage: "Meeting listings",
  },
  Production: { defaultMessage: "Production listings" },
});

const profileReviewMessages = defineMessages({
  bookAgain: { defaultMessage: "I would book again." },
  notBookAgain: { defaultMessage: " I would not book again." },
  no: { defaultMessage: "No," },
  yes: { defaultMessage: "Yes," },
  reviewsFromHost: { defaultMessage: "Reviews from Host" },
  numOfReviews: { defaultMessage: "({numOfReviews})" },
  avgRating: { defaultMessage: "Average Rating:" },
});

const profileHeaderMessages = defineMessages({
  joined: { defaultMessage: "Joined {joinedDate}" },
  defaultDescription: {
    defaultMessage:
      "Thanks for stopping by! I'm excited to be a part of the Peerspace community.",
  },
  messageHost: { defaultMessage: "Message Host" },
  shareProfile: { defaultMessage: "Share Profile" },
  verification: { defaultMessage: "Verification" },
  email: { defaultMessage: "Email" },
  phone: { defaultMessage: "Phone Number" },
  numOfReviews: {
    defaultMessage: "{count, plural, one {# review} other {# reviews}}",
  },
});

const profileModalMessages = defineMessages({
  messageHostTitle: { defaultMessage: "Select a listing to message {name}" },
  messageHostBody: {
    defaultMessage:
      "Pick a listing from this page and then click the 'Message host' button from the listing.",
  },
  messageHostCTA: { defaultMessage: "Got it" },
});

const profileErrorMessages = defineMessages({
  title: { defaultMessage: "We couldn't load this profile" },
  cta: { defaultMessage: "Try again" },
});

const profileListingMessages = defineMessages({
  from: { defaultMessage: "from" },
  priceHr: { defaultMessage: "{price}/hr" },
  share: { defaultMessage: "Share" },
});

export {
  profileErrorMessages,
  profileHeaderMessages,
  profileListingMessages,
  profileListingSectionTitles,
  profileModalMessages,
  profileReviewMessages,
};
